<template>
  <OneCol
    :center="true"
    :borderRadius="0"
    padding="0px"
    extraClass="smaller"
    :header="false"
  >
    <template v-slot:title></template>
    <template v-slot:body>
      <div class="button_wrap">
        <GenericButton
          @click="shareFacebook"
          text="Share on Facebook"
          textColor="white"
          preset="facebook"
        ></GenericButton>
        <GenericButton
          @click="shareWhatsapp"
          text="Share on WhatsApp"
          textColor="white"
          preset="whatsapp"
        ></GenericButton>
      </div>
      <div class="share_wrap">
        <SharePreview
          :title="$store.state.copy.meta.title"
          :desc="$store.state.copy.meta.desc"
          @click="shareFacebook"
          :image="$store.state.copy.meta.image"
        ></SharePreview>

        <GenericButton
          @click="gotoSlide('donate'), $store.commit('updateExtraProgress')"
          text="Skip"
          textColor="black"
          preset="text"
          fontSize="18px"
          :style="{marginTop: '20px !important'}"
        ></GenericButton>
      </div>
    </template>
  </OneCol>
</template>


<script>
import OneCol from "../components/template/OneCol";
import SharePreview from "../components/share/SharePreview";
import GenericButton from "../components/generic/GenericButton";
export default {
  name: "Share",
  components: {
    OneCol,
    SharePreview,
    GenericButton
  },
  methods: {
    shareFacebook() {
      const toShare = window.location.href.split("?")[0];
      const shareURL =
        "https://www.facebook.com/sharer/sharer.php?u=" +
        encodeURIComponent(toShare);
      window.open(
        shareURL,
        "_blank",
        "toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=250,top=300,left=300"
      );

      this.gotoSlide("donate");
      this.analytics("shared", "facebook");

      this.$store.commit("updateExtraProgress");
    },
    shareWhatsapp() {
      const whatsappText = this.$store.state.copy.meta.whatsapp;
      const here =
        window.location.href.split("?")[0] +
        "?utm_source=whatsapp&utm_medium=share";

      const shareURL =
        "https://api.whatsapp.com/send?text=" +
        encodeURIComponent(whatsappText + " " + here);
      window.open(
        shareURL,
        "_blank",
        "toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=450,top=300,left=300"
      );

      this.gotoSlide("donate");
      this.analytics("shared", "whatsapp");

      this.$store.commit("updateExtraProgress");
    }
  }
};
</script>
<style lang="scss" scoped>
.top_section {
  background: black;
  color: white;
  padding: 40px;
  @media (max-width: 767px) {
    padding: 12px;
    text-align: left;
  }
  p {
    font-family: Tahoma, Verdana, Segoe, sans-serif;
    font-size: 20px;
    line-height: 1.44;
    text-align: center;
    @media (max-width: 767px) {
      text-align: left;
      max-width: initial !important;
    }
    &:last-of-type {
      margin-bottom: 0;
    }

    &.green {
      color: #62ce00;
    }
  }
}

.button_wrap {
  margin-top: 10px;
  padding: 20px;
  @media (max-width: 767px) {
    padding: 5px 12px 0;
  }
}

.share_wrap {
  padding: 15px;
  @media (max-width: 767px) {
    padding: 12px;
  }
}
</style>